import { Component, OnInit, Input } from '@angular/core';
import { Product } from 'src/app/products/Products';

@Component({
  selector: 'app-product-price',
  templateUrl: './product-price.component.html',
  styleUrls: ['./product-price.component.css']
})
export class ProductPriceComponent implements OnInit {

  @Input() product: Product
  
  constructor() { }

  ngOnInit() {
  }

}
